import React, { useEffect, useState} from "react";
import translate from '../../../i18n/translate';
import "./CultureNotes.scss";
import allActions from '../../../redux/actions';
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import {useHistory} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { VectorMap } from "react-jvectormap";
import { countriesList, cultureNoteMapCoordinates } from '../../../globalConstants';
import { InputLabel, Select, MenuItem, FormControl, makeStyles } from "@material-ui/core";

const CultureNotes: React.FC = () => {

    const useStyles = makeStyles((theme) => ({
        root: {
            "& .MuiOutlinedInput-root": {
                borderRadius: '0'
            }
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 250,
            borderRadius: 0
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
            borderRadius: 0
        },
    }));

    const [cultureNotesFeatureEnabled, setCultureNotesFeatureEnabled] = useState(false);
    const [cultureNotesErrorEnabled, setCultureNotesErrorEnabled] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("");
    const [mapHeight, setMapHeight] = useState('500px');
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const allInfo = useSelector((state: any) => state);

    const redirecttoCountry = () => {
        history.push("/culturenotes/country");
    }

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28)) === "1") {
                setCultureNotesFeatureEnabled(true);
                setCultureNotesErrorEnabled(false);
            } else {
                setCultureNotesFeatureEnabled(false);
                setCultureNotesErrorEnabled(true);
            }
        }
    }, [allInfo.peopleInformation]);

    const handleChangeValue = (event: any, value: any) => {
      setSelectedCountry(event.target.value.length > 0 ? event.target.value : "");
      dispatch(allActions.commonActions.setSelectedCountry(event.target.value));
      redirecttoCountry();
    };

    useEffect(() => {
        if(window.innerWidth < 768 && window.innerWidth > 425) {
            setMapHeight("400px");
        } else if (window.innerWidth < 425) {
            setMapHeight("300px");
        }
    }, []);

    return (
        <span className="culture-Notes-Container">
        {cultureNotesFeatureEnabled &&
            <div className="culture_Notes_Container">
                <div className="culture_child_header">
                    <div className="CN-Title">
                        <h3 className="culture_header_text">
                            {translate("feature_cultureNotes_title")}
                        </h3>
                    </div>
                </div>

                <div className="map-container">
                    <VectorMap map={'world_mill'}
                    backgroundColor={"#3b96ce"}
                    containerStyle={{ 
                        width: '100%', 
                        height: mapHeight
                    }}
                    zoomOnScroll={false}
                    zoomAnimate={true}
                    containerClassName="map"
                    markers={cultureNoteMapCoordinates}
                    onMarkerClick={(data: any, str: any)=> {
                        dispatch(allActions.commonActions.setSelectedCountry(cultureNoteMapCoordinates[str].name));
                        Array.from(document.getElementsByClassName("jvectormap-tip")).forEach((el: any) => { el.style.display = 'none' }); 
                        redirecttoCountry();
                    }}
                    />
                </div>

            <div className="culture-notes-layout">
                <div className="culture-notes-body" >
                    <FormControl variant="outlined" className={`${classes.formControl} ${classes.root}`}>
                        <InputLabel id="demo-simple-select-outlined-label-location">Select country</InputLabel>
                        <Select
                            labelId="demo-simple-select-outlined-label-location"
                            id="Countries"
                            value={selectedCountry}
                            onChange={(event) => handleChangeValue(event, true)}
                            label={translate("SAL")}
                        >
                            {countriesList.map((option: any, index: number) => {
                                return (
                                    <MenuItem value={option}>{option}</MenuItem>        
                                );
                            })}
                        </Select>
                    </FormControl>
                    </div>
                </div>
            </div>
        }   
        {cultureNotesErrorEnabled && (
            <div className="culture-Notes-Errorpage">      
                <ErrorPage status={(process.env.REACT_APP_ENVIRONMENT !== "test" && cultureNotesFeatureEnabled) ? 500 : 401} />
            </div>
        )}     
       </span>
        );
}

export default CultureNotes;